import React from "react";
import PropTypes from "prop-types";
import Shimmer from "@fdn/bs_shimmer";

const PromoShimmer = ({ isMobile }) => (
	<div className="fds-promo-shimmer-wrapper">
		{
			[1, 2, 3, 4].map((item) => (
				<div
					className="fds-promo-shimmer"
					key={`list-shimmer-promotions-${item}`}
				>
					{
						!isMobile && (
							<Shimmer
								id="promotions-image"
								height="126px"
								width="252px"
							/>
						)
					}
					<div className="promotions-shimmer-info">
						<Shimmer
							id="promotions-title"
							height={isMobile ? "10px" : "20px"}
							width="50%"
						/>
						<Shimmer
							id="promotions-description"
							height={isMobile ? "10px" : "15px"}
							width={isMobile ? "100%" : "60%"}
						/>
						<Shimmer
							id="promotions-datetime"
							height={isMobile ? "10px" : "15px"}
							width="40%"
						/>
						<Shimmer
							id="promotions-button"
							height={isMobile ? "10px" : "15px"}
							width="80px"
						/>
					</div>

				</div>
			))
		}

		<style jsx>
			{`
				.fds-promo-shimmer-wrapper {
					padding-top: 5px;
				}
        .fds-promo-shimmer {
          margin: 16px;
					display: flex;
					padding: ${isMobile ? "15px 12px 0px" : "12px"};
					border: 1px solid #DFE3E8;
					flex-direction: space-between;
        }
				.promotions-shimmer-info {
					width: ${isMobile ? "100%" : "70%"};
					margin-left: ${isMobile ? "0" : "16px"};;
				}
      `}
		</style>
		<style>
			{`
				.fdn-shimmer-promotions-title{
					margin-bottom: ${isMobile ? "8px" : "18px"};
				}
				.fdn-shimmer-promotions-datetime{
					margin-bottom: ${isMobile ? "20px" : "26px"};
				}
			`}
		</style>
	</div>
);

PromoShimmer.propTypes = {
	isMobile: PropTypes.bool,
};

PromoShimmer.defaultProps = {
	isMobile: false,
};

export default PromoShimmer;
